module.exports = __webpack_public_path__ + "static/get-app-qr-db45052286861ece2d630ac0c0b72653.svg";